import CustomError from './custom-error'
class Sockette {
  constructor (url, opts = {}) {
    this.url = url
    this.opts = opts
    this.num = 0
    this.timer = 1
    this.max = opts.maxAttempts || Infinity
    this.ws = null
    this.lastError = null

    this.open()
  }

  static noop () {}

  static isFunction (variable) {
    return !!(
      variable &&
      variable.constructor &&
      variable.call &&
      variable.apply
    )
  }

  open () {
    const resolveUrl = Sockette.isFunction(this.url)
      ? this.url(this.num)
      : this.url

    Promise.resolve(resolveUrl).then(resolvedURL => {
      try {
        this.ws = new WebSocket(resolvedURL, this.opts.protocols || [])

        // Assign onmessage handler
        this.ws.onmessage = this.opts.onmessage || Sockette.noop

        // Assign onopen handler
        this.ws.onopen = event => {
          const onOpenHandler = this.opts.onopen || Sockette.noop

          onOpenHandler(event)
          this.num = 0
        }

        this.ws.onclose = e => {
          const isNormalClosure = e.code === 1000
          const isGoingAway = e.code === 1001
          const isNoStatusReceived = e.code === 1005

          if (!isNormalClosure && !isGoingAway && !isNoStatusReceived) {
            this.reconnect(e)
          }

          const onCloseHandler = this.opts.onclose || Sockette.noop
          onCloseHandler(e)
        }

        this.ws.onerror = e => {
          const isConnectionRefused = e && e.code === 'ECONNREFUSED'

          if (isConnectionRefused) {
            this.reconnect(e)
          } else {
            const onErrorHandler = this.opts.onerror || Sockette.noop
            onErrorHandler(e)
          }
        }
      } catch (error) {
        const onCloseHandler = this.opts.onclose || Sockette.noop
        onCloseHandler(
          new CustomError(
            'There was an error while trying to open the WebSocket connection.',
            'ECONSTRUCTIONFAILED',
            error
          )
        )
        console.log(
          'There was an error while trying to open the WebSocket connection.',
          error
        )
        this.close(error)
      }
    })
  }

  reconnect (e) {
    if (this.timer && this.num++ < this.max) {
      this.timer = setTimeout(() => {
        ;(this.opts.onreconnect || Sockette.noop)(e)
        this.open()
      }, this.opts.timeout || 1e3)
    } else {
      ;(this.opts.onmaximum || Sockette.noop)(e)
    }
  }

  json (x) {
    if (this.ws) {
      this.ws.send(JSON.stringify(x))
    } else {
      console.log('WebSocket is not open')
    }
  }

  send (x) {
    if (this.ws) {
      this.ws.send(x)
    } else {
      console.log('WebSocket is not open')
    }
  }

  close (x, y) {
    this.timer = clearTimeout(this.timer)
    if (this.ws) {
      this.ws.close(x || 1e3, y)
    } else {
      console.log('WebSocket is not open')
    }
  }
}

export default Sockette
